import React from 'react';
import {CheckoutButton} from './CheckoutButton/CheckoutButton';
import {CashierExpressButtons} from '../CashierExpressButtons/CashierExpressButtons';
import {useStores} from '../../StoresContext';
import {PaypalButton} from './PaypalButton/PaypalButton';
import s from './CheckoutButtons.scss';

export enum CheckoutButtonsDataHook {
  Default = 'CheckoutButtons.default',
  Top = 'CheckoutButtons.topView',
}

interface CheckoutButtonsProps {
  isOnTop?: boolean;
}

export function CheckoutButtons(props: CheckoutButtonsProps) {
  const {shouldShowDynamicPaymentOptions} = useStores().cashierExpressStore;
  const {isCheckoutRegularFlowEnabled, isCheckoutPayPalFastFlowEnabled} = useStores().cartStore;
  const {isOnTop} = props;
  const dataHook = isOnTop ? CheckoutButtonsDataHook.Top : CheckoutButtonsDataHook.Default;
  const {isCheckoutButtonDisabled} = useStores().navigationStore;

  return (
    <div data-hook={dataHook} className={s.checkoutButtons}>
      {isCheckoutRegularFlowEnabled && <CheckoutButton disabled={isCheckoutButtonDisabled} />}
      {shouldShowDynamicPaymentOptions ? (
        <CashierExpressButtons />
      ) : (
        isCheckoutPayPalFastFlowEnabled && <PaypalButton />
      )}
    </div>
  );
}
